export const adminLabel = "Admin";
